module.exports = __webpack_public_path__ + "assets/7585ae636ab290f2a24c3544a3f12782.svg";